import { Link, useSearch } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

const LAYOUT_ID = '/_authed/_active/s/$storeId/reports' as const;

const TABS = [
  { key: 'overview', to: '/s/$storeId/reports' },
  { key: 'sales', to: '/s/$storeId/reports/sales' },
  { key: 'products', to: '/s/$storeId/reports/products' },
  { key: 'customers', to: '/s/$storeId/reports/customers' },
  { key: 'payments', to: '/s/$storeId/reports/payments' },
  { key: 'inventory', to: '/s/$storeId/reports/inventory' },
  { key: 'auctions', to: '/s/$storeId/reports/auctions' },
  { key: 'support', to: '/s/$storeId/reports/support' },
  { key: 'analytics', to: '/s/$storeId/reports/analytics' },
] as const;

/** Route links styled as tabs; each keeps the selected range. */
export function ReportTabs({ storeId }: { storeId: string }) {
  const { t } = useTranslation('reports');
  const { range, from, to } = useSearch({ from: LAYOUT_ID });

  return (
    <nav
      aria-label={t('tabs.label')}
      className="max-w-full overflow-x-auto pb-4"
      data-tour="reports.tabs"
    >
      <div className="bg-muted text-muted-foreground inline-flex h-9 items-center rounded-lg p-[3px]">
        {TABS.map((tab) => (
          <Link
            key={tab.key}
            to={tab.to}
            params={{ storeId }}
            search={{ range, from, to }}
            activeOptions={{ exact: true, includeSearch: false }}
            activeProps={{ 'aria-current': 'page' }}
            className="data-[status=active]:bg-background data-[status=active]:text-foreground inline-flex h-[calc(100%-1px)] items-center rounded-md px-3 text-sm font-medium whitespace-nowrap transition-colors data-[status=active]:shadow-sm"
          >
            {t(`tabs.${tab.key}`)}
          </Link>
        ))}
      </div>
    </nav>
  );
}
